import { render } from "./MMAssessmentTable.vue?vue&type=template&id=49a3561e"
import script from "./MMAssessmentTable.vue?vue&type=script&lang=js"
export * from "./MMAssessmentTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__